import { brokerMessage } from './canonicalFields';

/** TradeStation Direct returns this text in `Message` on successful placement. */
const TS_DIRECT_SENT_ORDER_PREFIX = /^Sent order:/i;

function isSuccessfulPlacementOrder(order) {
  if (!order || typeof order !== 'object') return false;
  if (order.Error === 'FAILED' || order.Error === true) return false;
  const status = order.Status;
  if (status === 'REJ' || status === 'FAILED') return false;
  if (order.OrderID && !order.Error) return true;
  if (status === 'OPN' || status === 'ACK' || status === 'DON') return true;
  if (typeof order.Message === 'string' && TS_DIRECT_SENT_ORDER_PREFIX.test(order.Message)) return true;
  return false;
}

function singleOrderFailureMessage(order) {
  if (!order || typeof order !== 'object') return null;
  if (isSuccessfulPlacementOrder(order)) return null;
  if (order.RejectReason) return String(order.RejectReason);
  if (order.Reason) return String(order.Reason);
  const brokerMsg = brokerMessage(order);
  if (brokerMsg && !TS_DIRECT_SENT_ORDER_PREFIX.test(brokerMsg)) return String(brokerMsg);
  if (order.Status === 'REJ' || order.Status === 'FAILED') {
    return order.Message || order.RejectReason || `Order ${order.Status}`;
  }
  if (order.Error === 'FAILED' || order.Error === true) {
    return order.Message || 'Order failed';
  }
  if (order.Message && !TS_DIRECT_SENT_ORDER_PREFIX.test(order.Message)) {
    return String(order.Message);
  }
  return null;
}

/**
 * Human-readable failure message from a create-order API response, or null on success.
 * Handles HTTP errors ({ error }), TS Direct top-level errors, and rejected orders (REJ).
 */
export function parseCreateOrderFailure(result) {
  if (result == null || typeof result !== 'object') {
    return 'Order failed - no response from server';
  }
  if (Object.keys(result).length === 0) {
    return 'Order failed - no response from server';
  }
  if (result.error) return String(result.error);
  if (result.Error) return result.Message || String(result.Error);

  const orders = Array.isArray(result.Orders) ? result.Orders : [];
  const messages = orders.map(singleOrderFailureMessage).filter(Boolean);
  if (messages.length) return messages.join('; ');

  return null;
}

export function isCreateOrderSuccess(result) {
  return parseCreateOrderFailure(result) == null;
}

/** Human-readable failure from cancel-order API response, or null on success. */
export function parseCancelOrderFailure(result) {
  if (result == null || typeof result !== 'object') {
    return 'Cancel failed - no response from server';
  }
  if (Object.keys(result).length === 0) {
    return 'Cancel failed - no response from server';
  }
  if (result.error) return String(result.error);
  if (result.Error) return result.Message || String(result.Error);
  return null;
}

export function isCancelOrderSuccess(result) {
  return parseCancelOrderFailure(result) == null;
}

/** Human-readable failure from replace/update-order API response, or null on success. */
export function parseUpdateOrderFailure(result) {
  if (result == null || typeof result !== 'object') {
    return 'Order update failed - no response from server';
  }
  if (Object.keys(result).length === 0) {
    return 'Order update failed - no response from server';
  }
  if (result.error) return String(result.error);
  if (result.Error === 'FAILED' || result.Error === true || result.Error) {
    return result.Message || String(result.Error);
  }
  if (result.Status === 'REJ' || result.Status === 'FAILED') {
    return result.Message || result.RejectReason || `Order ${result.Status}`;
  }
  return null;
}

export function isUpdateOrderSuccess(result) {
  return parseUpdateOrderFailure(result) == null;
}
